// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/LeftSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var LeftSquareOutlined = function LeftSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareOutlinedSvg
  }));
};

LeftSquareOutlined.displayName = 'LeftSquareOutlined';
export default React.forwardRef(LeftSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LeftSquareOutlined.js
// module id = 1405
// module chunks = 0